/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DDiagramCanvasBaseShapeImpl } from "./d-diagram-canvas-base-shape-impl";

export class DDiagramCanvasEditorShapeImpl extends DDiagramCanvasBaseShapeImpl {}
